import { differenceInMinutes } from 'date-fns';

export const isWithinOneMinute = (currentDate: Date, existingDate: Date) => {
    if (
        differenceInMinutes(currentDate, existingDate) === 1 ||
        differenceInMinutes(currentDate, existingDate) === 0
    ) {
        return true;
    }

    return false;
};
